import React, { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  DateGet,
  catchError,
  compareDate,
  errData,
  handleDownloadDocument,
  maxDateSet,
  noDataFound,
} from "../CommonMethhods/CommonMethods";
import { SERVICES } from "../Configuration/Telecaller_URl";
import * as CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import Loader from "../Components/Common/Loader";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import LoaderForSearch from "../Components/Common/LoaderForSearch";
import axiosInstance from "../CommonMethhods/axiosInstance";

function AdminDashboard() {
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [errorData, setErrorData] = useState("");
  const [session, setSession] = useState(false);

  const adminschema = Yup.object().shape({
    fromDate: Yup.string()
      .required("Please enter from date")
      .test("is P", "Date should not be greater than current date", (value) => {
        return new Date(value).getTime() < new Date().getTime();
      })
      .test("is P", "From date should not be graeter than to date", (value) => {
        if (getAdminData("toDate") !== "") {
          return (
            new Date(value).getTime() <=
            new Date(getAdminData("toDate")).getTime()
          );
        } else {
          return true;
        }
      }),
    toDate: Yup.string()
      .required("Please enter to date")
      .test("is P", "Date should not be greater than current date", (value) => {
        return new Date(value).getTime() < new Date().getTime();
      })
      .test("is P", "To date should be graeter than from date", (value) => {
        if (getAdminData("fromDate") !== "") {
          return (
            new Date(value).getTime() >=
            new Date(getAdminData("fromDate")).getTime()
          );
        } else {
          return true;
        }
      }),
    radioData: Yup.string().required().nullable(),
  });
  const {
    register: registerAdmin,
    handleSubmit: handleShow,
    formState: { errors: dateError },
    setValue: setAdminValues,
    setError: setDobErr,
    watch: watchDob,
    clearErrors: clearDob,
    reset: resetDob,
    getValues: getAdminData,
    trigger,
  } = useForm({
    mode: "all",
    resolver: yupResolver(adminschema),
  });

  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }

  useEffect(() => {
    setAdminValues("radioData", "report");
  }, []);
  const sessionExpired = () => {
    setSession(false);
    localStorage.clear("");
    navigate("/");
  };
  useEffect(() => {
    if (reportData.length > 0 && page !== 1) {
      setScrollLoader(true);
      adminReportData(getAdminData(), page, "grid");
    }
  }, [page]);

  const adminReportData = async (value, page, fileType) => {
    let updateAdmin = {
      dashboardType: value.radioData,
      fromDate: moment(value.fromDate, "YYYY-MM-DD").format("MM-DD-YYYY"),
      toDate: moment(value.toDate, "YYYY-MM-DD").format("MM-DD-YYYY"),
      pageSize: fileType === "grid" ? 10 : -1,
      pageNo: page,
      userId: localStorage.getItem("userId"),
      type: fileType,
    };

    let encPayload=AESEncryption(updateAdmin);
    try {
      const response = await axiosInstance.post(
        `${SERVICES.ADMIN_DASHBOARD}`,
        encPayload,
      );
      const data = await response.data;
      let storeResponse = ApiResDecrypt(data);
      // const res = storeResponse.data;
      if (fileType == "grid") {
        if (storeResponse.status == 0) {
          if (storeResponse.data.report) {
            setReportData((prev) => {
              return [...prev, ...storeResponse.data.report];
            });
            setCount(storeResponse.data.totalcount);
            setShowTable(true);
            setErrorData("");
          }
          if (storeResponse.data.payment) {
            setReportData((prev) => {
              return [...prev, ...storeResponse.data.payment];
            });
            setCount(storeResponse.data.totalcount);
            setShowTable(true);
            setErrorData("");
          }
        } else {
          setShowTable(false)
          // setReportData(storeResponse.message)
          setErrorData("No Data Found");
        }
      } else if (fileType == "excel") {
        handleDownloadDocument(storeResponse.data);
      }
    } catch (err) {
      setShowTable(false);
      setReportData([]);
      setErrorData("Something Went Wrong");
      // catchError(err)
      if (err.request.status == "401") {
        // toast.error("session expired")
        // localStorage.clear("");
        // navigate("/login");
        setSession(true);
      } else {
      }
    } finally {
      // setReportData([])
      setLoader(false);
      setScrollLoader(false);
    }
  };

  const downloadExcel = (value) => {
    adminReportData(value, 1, "excel");
  };
  const handleOnClick = (value) => {
    setReportData([]);
    setLoader(true);
    setPage(1);
    adminReportData(value, 1, "grid");
  };

  const showTableData = (reportData) => {
    return (
      reportData &&
      reportData.map((item, key) => {
        const {
          date,
          register,
          verifyKyc,
          personalDetails,
          payment,
          freedomPack,
          documents,
          ipv,
          accountOpened,
          dataMovedtoCitrus,
        } = item;
        return (
          <tr key={key}>
            <td>{date === "" || undefined || null ? "-" : date}</td>
            <td>{register === "" || undefined || null ? "-" : register}</td>
            <td>{verifyKyc === "" || undefined || null ? "-" : verifyKyc}</td>
            <td>
              {personalDetails === "" || undefined || null
                ? "-"
                : personalDetails}
            </td>
            <td>{payment === "" || undefined || null ? "-" : payment}</td>
            <td>
              {freedomPack === "" || undefined || null ? "-" : freedomPack}
            </td>
            <td>{documents === "" || undefined || null ? "-" : documents}</td>
            <td>{ipv === "" || undefined || null ? "-" : ipv}</td>
            <td>
              {accountOpened === "" || undefined || null ? "-" : accountOpened}
            </td>
            <td>
              {dataMovedtoCitrus === "" || undefined || null
                ? "-"
                : dataMovedtoCitrus}
            </td>
          </tr>
        );
      })
    );
  };

  const handleOnScroll = (id) => {
    let scrollData = document.querySelector(`#${id}`);
    if (
      scrollData.scrollTop + scrollData.offsetHeight >=
      scrollData.scrollHeight
    ) {
      if (count <= 10 * page) {
        return;
      }
      setPage((prev) => prev + 1);
    }
  };
  // const showPaymentTableData = (reportData) => {
  //   return (
  //     reportData &&
  //     reportData.map((item, key) =>
  //       <tr key={key}>
  //         <td>{item.date === "" || undefined || null ? "-" : item.date}</td>
  //         <td>
  //           {item.registerRejected === "" || undefined || null
  //             ? "-"
  //             : item.registerRejected}
  //         </td>
  //         <td>
  //           {item.success === "" || undefined || null ? "-" : item.success}
  //         </td>
  //         <td>
  //           {item.freedomPack === "" || undefined || null
  //             ? "-"
  //             : item.freedomPack}
  //         </td>
  //         <td>
  //           {item.failure === "" || undefined || null ? "-" : item.failure}
  //         </td>
  //         <td>
  //           {item.tobeConfirmed === "" || undefined || null
  //             ? "-"
  //             : item.tobeConfirmed}
  //         </td>
  //       </tr>

  //     )
  //   );
  // };

  return (
    <>
      <div className="telecaller telecallerDash">
        <div className="card-box">
          <div className="admin-dash-radio">
            <input
              type="radio"
              name="data"
              value="report"
              defaultChecked={getAdminData("radioData") === "report"}
              onClick={(e) => setAdminValues("radioData", "report")}
              {...registerAdmin("radioData")}
            />
            <label htmlFor="">Report Data</label>
            <input
              type="radio"
              id="html"
              name="data"
              value="payment"
              defaultChecked={getAdminData("radioData") === "payment"}
              onClick={(e) => setAdminValues("radioData", "payment")}
              {...registerAdmin("radioData")}
            />
            <label htmlFor="">Payment Data</label>
          </div>

          <div className="row telecaller-form">
            <div className="col-md-4 col-sm-6 col-6">
              <div className="form-group">
                <label className="form-label">
                  From Date<span className="star_text">*</span>
                </label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className={`datepicker form-control ${
                    dateError?.fromDate ? "is-invalid" : ""
                  }`}
                  {...registerAdmin("fromDate", {
                    onChange: () => {
                      if (getAdminData("toDate") !== "") {
                        trigger("toDate");
                        setShowTable(false);
                        setErrorData("");
                      }
                    },
                  })}
                  max={DateGet.maxToday}
                  // min={DateGet.minTenyear}
                  id="FromDate"
                />
                <div className="invalid-feedback number-field">
                  {dateError.fromDate?.message}
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-6">
              <div className="form-group ">
                <label className="form-label">
                  To Date<span className="star_text">*</span>
                </label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className={`datepicker form-control ${
                    dateError?.toDate ? "is-invalid" : ""
                  }`}
                  {...registerAdmin("toDate", {
                    onChange: () => {
                      if (getAdminData("fromDate") !== "") {
                        trigger("fromDate");
                        setShowTable(false);
                        setErrorData("");
                      }
                    },
                  })}
                  max={DateGet.maxToday}
                  id="ToDate"
                />
                <div className="invalid-feedback number-field">
                  {dateError.toDate?.message}
                </div>
              </div>
            </div>
            <div className="tele-btn-wrapper">
              <button
                value="submit"
                className="send-message"
                onClick={handleShow(handleOnClick)}
              >
                SHOW SUMMARY
              </button>
              <button
                className="send-message"
                type="button"
                onClick={handleShow(downloadExcel)}
              >
                DOWNLOAD DATA
              </button>
              {/* </a> */}
            </div>
          </div>
          <div>
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              <>
                <div className="table-responsive scroll-table telecaller-table-wrapper">
                  {showTable ? (
                    // <>{getAdminData("radioData") === "report" && <>cger</>}</>
                    <>
                      {getAdminData("radioData") === "report" && (
                        <>
                          <div className="table-responsive scroll-table telecaller-table-wrapper">
                            <table
                              className="table"
                              cellSpacing={0}
                              cellPadding={0}
                            >
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Register</th>
                                  <th>Verify KYC</th>
                                  <th>Personal Details</th>
                                  <th>Payment</th>
                                  <th>Freedom pack</th>
                                  <th>Documents</th>
                                  <th>IPV</th>
                                  <th>Account Opened</th>
                                  <th>Data Moved to Citrus</th>
                                </tr>
                              </thead>
                              <tbody
                                id="reporttabledata"
                                onScroll={(e) =>
                                  handleOnScroll("reporttabledata")
                                }
                              >
                                {/* {showTableData(reportData)} */}
                                {reportData &&
                                  reportData.map((item, key) => {
                                    const {
                                      date,
                                      register,
                                      verifyKyc,
                                      personalDetails,
                                      payment,
                                      freedomPack,
                                      documents,
                                      ipv,
                                      accountOpened,
                                      dataMovedtoCitrus,
                                    } = item;
                                    return (
                                      <tr key={key}>
                                        <td>
                                          {date === "" || undefined || null
                                            ? "-"
                                            : date}
                                        </td>
                                        <td>
                                          {register === "" || undefined || null
                                            ? "-"
                                            : register}
                                        </td>
                                        <td>
                                          {verifyKyc === "" || undefined || null
                                            ? "-"
                                            : verifyKyc}
                                        </td>
                                        <td>
                                          {personalDetails === "" ||
                                          undefined ||
                                          null
                                            ? "-"
                                            : personalDetails}
                                        </td>
                                        <td>
                                          {payment === "" || undefined || null
                                            ? "-"
                                            : payment}
                                        </td>
                                        <td>
                                          {freedomPack === "" ||
                                          undefined ||
                                          null
                                            ? "-"
                                            : freedomPack}
                                        </td>
                                        <td>
                                          {documents === "" || undefined || null
                                            ? "-"
                                            : documents}
                                        </td>
                                        <td>
                                          {ipv === "" || undefined || null
                                            ? "-"
                                            : ipv}
                                        </td>
                                        <td>
                                          {accountOpened === "" ||
                                          undefined ||
                                          null
                                            ? "-"
                                            : accountOpened}
                                        </td>
                                        <td>
                                          {dataMovedtoCitrus === "" ||
                                          undefined ||
                                          null
                                            ? "-"
                                            : dataMovedtoCitrus}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                              {scrollLoader && (
                                <div className="loader-center">
                                  <LoaderForSearch />
                                </div>
                              )}
                            </table>
                          </div>
                        </>
                      )}
                      {getAdminData("radioData") === "payment" && (
                        <>
                          <div className="table-responsive scroll-table telecaller-table-wrapper">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Register</th>
                                  <th>Success</th>
                                  <th>Freedom Pack</th>
                                  <th>Failure</th>
                                  <th>To be confirmed</th>
                                </tr>
                              </thead>
                              <tbody
                                id="paymenttabledata"
                                onScroll={() =>
                                  handleOnScroll("paymenttabledata")
                                }
                              >
                                {/* {showPaymentTableData(reportData)} */}
                                {reportData &&
                                  reportData.map((item, key) => (
                                    <tr key={key}>
                                      <td>
                                        {item.date === "" || undefined || null
                                          ? "-"
                                          : item.date}
                                      </td>
                                      <td>
                                        {item.registerRejected === "" ||
                                        undefined ||
                                        null
                                          ? "-"
                                          : item.registerRejected}
                                      </td>
                                      <td>
                                        {item.success === "" ||
                                        undefined ||
                                        null
                                          ? "-"
                                          : item.success}
                                      </td>
                                      <td>
                                        {item.freedomPack === "" ||
                                        undefined ||
                                        null
                                          ? "-"
                                          : item.freedomPack}
                                      </td>
                                      <td>
                                        {item.failure === "" ||
                                        undefined ||
                                        null
                                          ? "-"
                                          : item.failure}
                                      </td>
                                      <td>
                                        {item.tobeConfirmed === "" ||
                                        undefined ||
                                        null
                                          ? "-"
                                          : item.tobeConfirmed}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                              {scrollLoader && (
                                <div className="loader-center">
                                  <LoaderForSearch />
                                </div>
                              )}
                            </table>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>{errorData !== "" && errData(errorData)}</>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={session}
        onHide={() => setSession(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        className="popup rm-model session-expired"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {/* Change Gender */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="section-title">
            Session has been expired,Please Login again...
          </h4>
          <div className="btn-yes-no">
            <Button
              className="yes-btn confirmation-btn"
              onClick={() => sessionExpired()}
            >
              OK
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default AdminDashboard;
